import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { map } from '@store/selectors';
import { useAppDispatch, useAppSelector } from '@store/store';

import { setSnackbar } from '@slices/common';
import { setIsMapDataUpdateNeeded } from '@slices/map';

import { createAsset } from '@api/assets';

import { ESnackbarTypes } from '@enums/common';

import { ASSETS, ASSETS_LIST, CREATE_ASSET, FILTER_THRESHOLDS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateAsset = (onSuccessCallbacks?: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		appliedAssetsFilterValues: { detailed, ...filter },
		bounds,
		zoomLvl,
		clusterZoomLvl,
	} = useAppSelector(map);

	const mapParams = {
		boundingBox: {
			bottomLeftLng: bounds?.sw?.lng,
			bottomLeftLat: bounds?.sw?.lat,
			topRightLng: bounds?.ne?.lng,
			topRightLat: bounds?.ne?.lat,
		},
		zoom: zoomLvl,
		filter,
		detailed,
		clusterZoomLvl,
	};

	const {
		mutate: handleCreateAsset,
		isLoading: isLoadingCreateAsset,
	} = useMutation({
		mutationKey: [CREATE_ASSET],
		mutationFn: createAsset,
		onSuccess: () => {
			if (onSuccessCallbacks?.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}

			dispatch(setIsMapDataUpdateNeeded(true));
			dispatch(setSnackbar({
				message: responseMessages.createdAsset,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([ASSETS_LIST]),
				queryClient.invalidateQueries([FILTER_THRESHOLDS]),
				queryClient.invalidateQueries([ASSETS, mapParams]),
			];
		},
	});

	return { handleCreateAsset, isCreatingAsset: isLoadingCreateAsset };
};
